import { render, staticRenderFns } from "./personal-data.vue?vue&type=template&id=354b92ae&scoped=true"
import script from "./personal-data.vue?vue&type=script&lang=js"
export * from "./personal-data.vue?vue&type=script&lang=js"
import style0 from "./personal-data.vue?vue&type=style&index=0&id=354b92ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354b92ae",
  null
  
)

export default component.exports